import React from "react";

export const PRIORITY_STYLE = {
  Critical: { bg: "#FEF2F2", text: "#991B1B", border: "#FCA5A5", dot: "🔴" },
  High: { bg: "#FFF7ED", text: "#C2410C", border: "#FDBA74", dot: "🟠" },
  Medium: { bg: "#EFF6FF", text: "#1E40AF", border: "#93C5FD", dot: "🔵" },
  Low: { bg: "#F8FAFC", text: "#475569", border: "#E2E8F0", dot: "⚪" },
};

export const HEALTH_STYLE = {
  Healthy: { bg: "#F0FDF4", text: "#166534", border: "#86EFAC", dot: "🟢" },
  "At Risk": { bg: "#FEFCE8", text: "#854D0E", border: "#FDE047", dot: "🟡" },
  Overdue: { bg: "#FFF7ED", text: "#C2410C", border: "#FDBA74", dot: "🟠" },
  Blocked: { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1", dot: "⚫" },
};

export const STATUS_STYLE = {
  Draft: "#64748B",
  "Not Started": "#64748B",
  Open: "#2563EB",
  "In Progress": "#7C3AED",
  Waiting: "#CA8A04",
  "On Hold": "#9333EA",
  Completed: "#16A34A",
  Closed: "#15803D",
  Cancelled: "#94A3B8",
};

export function Badge({ style, children, testid }) {
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{ backgroundColor: style?.bg, color: style?.text, borderColor: style?.border }}
    >
      {style?.dot && <span className="text-[9px] leading-none">{style.dot}</span>}
      {children}
    </span>
  );
}

export function PriorityBadge({ value }) {
  const s = PRIORITY_STYLE[value] || PRIORITY_STYLE.Low;
  return <Badge style={s} testid={`priority-badge-${(value || "").toLowerCase()}`}>{value}</Badge>;
}

export function HealthBadge({ value }) {
  const s = HEALTH_STYLE[value] || HEALTH_STYLE.Healthy;
  return <Badge style={s} testid={`health-badge-${(value || "").toLowerCase().replace(/ /g, "-")}`}>{value}</Badge>;
}

export function StatusBadge({ value }) {
  const color = STATUS_STYLE[value] || "#64748B";
  return (
    <span
      data-testid={`status-badge-${(value || "").toLowerCase().replace(/ /g, "-")}`}
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium"
      style={{ backgroundColor: color + "15", color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      {value}
    </span>
  );
}

export function ReviewBadge({ value }) {
  if (!value || value === "Not Required") return null;
  const map = {
    "Pending Approval": "#1E40AF",
    "Pending Review": "#7C3AED",
    Approved: "#16A34A",
    Rejected: "#DC2626",
    Returned: "#CA8A04",
  };
  const color = map[value] || "#64748B";
  return (
    <span className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium"
      style={{ backgroundColor: color + "15", color }}>
      {value}
    </span>
  );
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}
